import { writable, get } from 'svelte/store';
import { v4 as uuidv4 } from 'uuid';
import deepmerge from 'deepmerge';
import { pageDefaults, addDefaultStyle } from './PaywallComponents/components'
import { addPaywallJS } from './paywall'

import { loadPaywall, syncPaywall }  from './BackendServices/paywallServices'
import { loadProject, saveProject, duplicateProject, setViewerConnected, listenForViewers } from './BackendServices/projectServices'
import { compute_rest_props } from 'svelte/internal';

// firebase

let components = []

const urlParams = new URLSearchParams(window.location.search);

let livePaywallDidLoad = false
let stateId = urlParams.get('id')
stateId = stateId ? stateId.replace("?transport=editor", "") : stateId
window.history.replaceState(null, null, location.href.replace('?transport=editor', '&transport=editor'));
let isProjectLoaded = !urlParams.has('project_id')
let projectId = urlParams.has('project_id') ? urlParams.get('project_id') : uuidv4()
let shouldSync = urlParams.get('sync') == "1" || urlParams.get('sync') == "true"
let live = urlParams.get('live') == "1" || urlParams.get('live') == "true" || shouldSync

export const getProjectId = () => {
	return projectId
}

if (!urlParams.has('project_id') && !live) {
	window.history.replaceState(null, null, "?project_id=" + projectId);
}

export const State = writable({
    previewMode: true,
	live: (live) ? true : false,
    activeElementId: components.length > 1 ? components[0].id : "",
    components: components,
	page: pageDefaults,
	fonts: {},
});

export const ViewerState = writable({
    isConnected: false
});


var updatedSyncViewerConnectedFlag = false

if (shouldSync) {
	syncPaywall(projectId, (data) => {
		State.update(v => { 
			v.components = data.components
			v.page = deepmerge(pageDefaults, data.page)
			addDefaultStyle(v)
			setViewerConnected(projectId)
			return v
		})
	})
}

const viewersChanged = (isConnected) => {
	ViewerState.set({isConnected: isConnected})
}

export const startListeningForViewers = () => {
	listenForViewers(projectId, viewersChanged)
}

if (!isProjectLoaded) {
	loadProject(projectId, (data) => {
		if (data !== null) {
			State.update(v => { 
				v.components = data.components
				v.page = deepmerge(pageDefaults, data.page)
				v.fonts = data.fonts
				addDefaultStyle(v)
				isProjectLoaded = true
				if (!shouldSync) {
					duplicateProject(v, (pid) => {
						projectId = pid
					})
				}
				return v
			})
		} else {
			duplicateProject(get(State), (pid) => {
				projectId = pid
			})
		}
	})
}



let stateChanged = false

setInterval(() => {
	if (isProjectLoaded && !live && stateChanged) {
		saveProject(projectId, get(State))		
		stateChanged = false
	}
}, 50)

State.subscribe(async (v) => {
	stateChanged = true
	if (livePaywallDidLoad) {
		console.log("waiting for dom to load ...")
		await addPaywallJS()
	}
})

if (stateId !== null) {
	loadPaywall(stateId, (data) => {
		State.update(v => { 
			console.log("paywall loaded!")
			v.components = data.components
			v.page = deepmerge(pageDefaults, data.page)
			v.fonts = data.fonts ?? {}
			addDefaultStyle(v)
			livePaywallDidLoad = true
			return v
		})
	})
}

let lastUrl = location.href; 
new MutationObserver(() => {
  const url = location.href;
  if (url !== lastUrl) {
    lastUrl = url;
    onUrlChange();
  }
}).observe(document, {subtree: true, childList: true});
 
 
function onUrlChange() {
	if (window.location.href.includes('?transport=editor')) {
		window.history.replaceState(null, null, location.href.replace('?transport=editor', '&transport=editor'));
	}
}

import FastClick from 'fastclick'


if ('addEventListener' in document) {
	document.addEventListener('DOMContentLoaded', function() {
		setTimeout(() => {
			console.log("adding fastclick")
			FastClick(document.body);
		}, 1000)
	}, false);
}


export const adjustOrderForFixedItems = (input) => {
	let elements = input
	let foundFixedFooter = false

	let beginning = []
	let end = []

	for (let i = 0; i < elements.length; i++) {
		let element = elements[i]
		if (element !== undefined) {
			console.log(elements[i])
			elements[i].args.meta.section = "body"
			if (element.type == "fixedFooter") {
				foundFixedFooter = true
			} 
			
			if (element.type == "navBar") {
				beginning.splice(0,0,elements[i])
			} else if (foundFixedFooter) {
				elements[i].args.meta.section = "footer"
				end.push(elements[i])
			} else {
				beginning.push(elements[i])
			}
		}
	}

	if (end.length > 1) {
		end[0].args.meta.shouldHide = true
	} else if (end.length > 0) {
		end[0].args.meta.shouldHide = false
	}

	return [...beginning, ...end]
}